import { render, staticRenderFns } from "./RealEstatePriceLabs.vue?vue&type=template&id=009010a8&scoped=true&"
import script from "./RealEstatePriceLabs.vue?vue&type=script&lang=js&"
export * from "./RealEstatePriceLabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009010a8",
  null
  
)

export default component.exports